import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { Inbox } from './routes/Inbox';
import { Submit } from './routes/Submit';
import { AdminPrompts } from './routes/AdminPrompts';
import { AuthGate } from './components/AuthGate';

function ReviewRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={id ? `/inbox/${id}` : '/inbox'} replace />;
}

export function App() {
  return (
    <AuthGate>
      <Routes>
        <Route path="/" element={<Navigate to="/inbox" replace />} />
        <Route path="/inbox" element={<Inbox />} />
        <Route path="/inbox/:id" element={<Inbox />} />
        <Route path="/submit" element={<Submit />} />
        <Route path="/admin/prompts" element={<AdminPrompts />} />
        <Route path="/review/:id" element={<ReviewRedirect />} />
        <Route path="*" element={<Navigate to="/inbox" replace />} />
      </Routes>
    </AuthGate>
  );
}
